import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Breadcrumb, Card, Col, Container, Row } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom';
import { Users } from '../../api/Users';
import AppLoader from '../../components/AppLoader';
import { User } from '../../models/User'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { useToasts } from "../../contexts/toasts";

export default function UserDetail() {
  const { id } = useParams();
  const [user, setUser] = useState<User>();
  const { showToast } = useToasts();

  useEffect(() => {
    initUser();
  }, []);

  const initUser = () => {
    Users.getUser(id!)
      .then(
        ({ data: user }) => setUser(user),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast!(
            "user-error",
            message,
            `User Error ${status ? `(${status})` : ""}`,
            "danger"
          );
        }
      )
  };

  const renderUser = () => {
    return (
      <>
        <Card.Body className="">
          <Row>
            <Col>
              <div className="d-flex align-items-center mb-2">
                <Col md={4}>
                  <h6 className="mb-0">Name</h6>
                </Col>
                <Col md={8}>
                  <p className="mb-0">{user?.firstname + " " + user?.lastname}</p>
                </Col>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex align-items-center mb-2">
                <Col md={4}>
                  <h6 className="mb-0">Role</h6>
                </Col>
                <Col md={8}>
                  <p className="mb-0">{user?.role}</p>
                </Col>
              </div>

            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex align-items-center mb-2">
                <Col md={4}>
                  <h6 className="mb-0">Email</h6>
                </Col>
                <Col md={8}>
                  <p className="mb-0">{user?.email}</p>
                </Col>
              </div>

            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex align-items-center mb-2">
                <Col md={4}>
                  <h6 className="mb-0">Username</h6>
                </Col>
                <Col md={8}>
                  <p className="mb-0">{user?.username}</p>
                </Col>
              </div>

            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex align-items-center mb-2">
                <Col md={4}>
                  <h6 className="mb-0">Taxcode</h6>
                </Col>
                <Col md={8}>
                  <p className="mb-0">{user?.taxCode}</p>
                </Col>
              </div>

            </Col>
          </Row>
          {user?.role == "patient" ?
            <Row>
              <Col>
                <div className="d-flex align-items-center mb-2">
                  <Col md={4}>
                    <h6 className="mb-0"> Ref Doctor</h6>
                  </Col>
                  <Col md={8}>
                    <p className="mb-0">{user?.refDoctor?.name}</p>
                  </Col>
                </div>

              </Col>
            </Row>
            : ""
          }
          {user?.role == "patient" ?
            <Row>
              <Col>
                <div className="d-flex align-items-center mb-2">
                  <Col md={4}>
                    <h6 className="mb-0">Pathology</h6>
                  </Col>
                  <Col md={8}>
                    <p className="mb-0">{user?.pathology?.name}</p>
                  </Col>
                </div>

              </Col>
            </Row>
            : ""
          }
          <Row>
            <Col>
              <div className="d-flex align-items-center mb-2">
                <Col md={4}>
                  <h6 className="mb-0">Groups</h6>
                </Col>
                <Col md={8}>
                  {user?.role !== "admin" && user?.groups!?.length > 0 && (
                    user?.groups!.map((group: any, index) => (
                      <Badge bg="secondary" key={"gBadge-" + index} style={{ marginRight: "5px" }}>
                        <FontAwesomeIcon icon={solid('users')} />
                        <span >{group.name}</span>
                      </Badge>))

                  )}
                  {user?.role !== "admin" && user?.groups!?.length === 0 && (
                    <Badge bg="warning">
                      <FontAwesomeIcon icon={solid('question-circle')} />
                      <span >{t('usersList.noGroup') as String}</span>
                    </Badge>
                  )}
                </Col>
              </div>

            </Col>
          </Row>
        </Card.Body>
      </>
    );
  }

  const renderAsyncContent = () => {
    return user
      ? renderUser()
      : (
        <div className="d-flex py-3 justify-content-center">
          <AppLoader size={150} />
        </div>
      )
  }

  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/users` }}>
          {t("pages.users") as string}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {user?.firstname + " " + user?.lastname}
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card>{renderAsyncContent()}</Card>
    </Container>
  )
}